module.exports = __webpack_public_path__ + "assets/31ecdbe7a1831625eab460a1ac8ee78d.png";